<!-- 编辑和删除支付方式 -->
<template>
    <div>
        <van-nav-bar
		  	:title="$t('platform.editAdd')"
			left-arrow
			fixed
			z-index='9'
		  	@click-left="$router.push('/AddressList')">
		    <van-icon name="./static/img/Trash.png" slot="right"  style="font-size: 24px;" @click="deleteAddress()"/>
		</van-nav-bar>
        <div class="contentWrapper">
        	<van-field
				v-model="name"
				:label="$t('platform.name')"
				clearable
				:placeholder="$t('platform.inputName')"
			/>
		   <van-field
				v-model="price"
				:label="$t('platform.price')"
				clearable
				:placeholder="$t('platform.inputPrice')"
           />
           <!-- 提交按钮 -->
           <div class="bottom">
			<van-button class="issueBtn" round type="default"  style="font-weight:bold;font-size:16px;" @click="updateAddress()">{{$t('EditStaff.submit')}}</van-button>
		</div>
		</div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            name:'',
            price:'',
        };
    },
    created(){
    	this.name = sessionStorage.addressName;
    	this.price = sessionStorage.addressPrice;
    },
    methods:{
        // 提交修改
        updateAddress(){
            if(this.name && this.price){
				this.$axios({
					method: 'PATCh',
					headers: {
						"Authorization": 'Bearer '+sessionStorage.token,
					},
					url: this.$build+'/api/additional/'+this.$route.params.id+'/update',
					data:{
						name:this.name,
						price:this.price,
					}
				}).then(res => {
					if(res.data.status==200){
						console.log(res);
						this.$toast({
							type:'success',
							message:res.data.message,
                        });
                        var vm = this;
                        setTimeout(()=>{
                            vm.$router.push('/AddressList')
                        },1000)
					}else{
						for (var item in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[item],
							});
						}
					}
				}).catch(err => {
					this.$toast({
						type:'fail',
						message:this.$t('StaffList.message'),
					});
				});
			}else{
				this.$toast({
					type:'fail',
					message:this.$t('NewDish.toast')
				});
			}
        },
        // 删除地区
        deleteAddress(){
            this.$dialog.confirm({
			  	title:this.$t('platform.delete'),
			  	message:this.$t('platform.isDelete'),
			  	confirmButtonColor:'#2f75f4',
			  	confirmButtonText:this.$t('vantText.confirm'),
				cancelButtonText:this.$t('vantText.cancel')
			}).then(()=>{
                this.$axios({
                method: 'DELETE',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/additional/'+this.$route.params.id+'/destroy',
                }).then(res => {
                    if(res.data.status==200){
                        console.log(res);
                        this.$toast({
                            type:'success',
                            message:res.data.message,
                        });
                        var vm = this;
                        setTimeout(()=>{
                            vm.$router.push('/AddressList')
                        },1000)
                    }else{
                        for (var item in res.data.error) {
                            this.$toast({
                                type:'fail',
                                message:res.data.error[item],
                            });
                        }
                    }
                }).catch(err => {
                    this.$toast({
                        type:'fail',
                        message:this.$t('StaffList.message'),
                    });
                });
            }).catch(err=>{
                console.log(err)
            }) 
        }
    }
}

</script>
<style scoped>
    /deep/ .van-nav-bar .van-icon{
        font-size: 24px;
        color: #fff;
    }
	@media screen and (min-width: 800px) {
  		.bottom {
  		  width: 800px;
  		  margin: 0 auto;
  		}
	}
	@media screen and (max-width: 800px) {
	  .bottom {
	    width: 100%;
	    margin: 0 auto;
	  }
	}
    .bottom{
		position: fixed;
		bottom: 0;
		/* width: 100%; */
		height: 60px;
		background: #F3F5F7;
	}
    .issueBtn{
		width: 90%;
		position: absolute;
		left: 50%;
		top: 50%;
		color: #fff;
		transform: translate(-50%,-50%);
		background: #000;
	}
	/deep/ .van-picker__cancel, /deep/ .van-picker__confirm{
		color: #2f75f7;
	}
	/deep/ .van-field__label{
		width: 80px;
	}
</style>


// WEBPACK FOOTER //
// src/Address/EditAddress.vue